import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { LinkedAccountsState } from 'typings/reduxStore'

export const initState: LinkedAccountsState = {
  dataList: [],
  dataListCount: 0,
  error: false,
  errorMessage: '',
  gridOption: {
    currentPage: 1,
    limit: 10
  },
  isDataLoading: true,
  linkedAccountStatus: '',
  newLinkedAccount: {
    userId: '',
    password: ''
  }
}

const linkedAccountsSlice = createSlice({
  name: 'linkedAccountsSlice',
  initialState: initState,
  reducers: {
    updateLinkedAccountsState: (
      state: LinkedAccountsState,
      action: PayloadAction<LinkedAccountsState>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    }
  }
})

export const { updateLinkedAccountsState } = linkedAccountsSlice.actions

export default linkedAccountsSlice.reducer
